<mat-card>
    <mat-card-header>
        <mat-card-title>
            Region {{regionCode}}: Unresolved SSID Matches ( {{tableDataSource.data.length}} )
            <help-text-btn class="align-help-text-btn" [helpTextId]="'Unresolved_overview'"></help-text-btn>
            <br>
        </mat-card-title>
    </mat-card-header>
</mat-card>
<mat-divider></mat-divider>


<br>
<div *ngIf="isLoading">
    <mat-spinner></mat-spinner>
</div>
<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

<div *ngIf="msg.SUCCESS && !this.isLoading" class="margin-top-md">
    <div class="row">
        <mat-form-field class="col-lg-12">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Filter items below"
                class="txtDistrictFilterMatCss" #input>
        </mat-form-field>
    </div>
    <div class="row   table-responsive">
        <mat-table [dataSource]="tableDataSource" (matSortChange)="setupSorting($event)" matSort
            class="mat-elevation-z8">

            <ng-container matColumnDef="Action">
                <mat-header-cell *matHeaderCellDef style="min-width:70px;">
                    Action
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" matTooltip="Edit">
                        <mat-icon (click)="goToPage(element)">edit</mat-icon>
                    </button>

                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Name
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.PERSON.LAST_NAME |
                    titlecase}}{{(element.PERSON.SECOND_LAST_NAME
                    ? ' ' + element.PERSON.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
                    titlecase}}
                    {{element.PERSON.MIDDLE_INITIAL | titlecase}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="MSDNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <edit-child-modal-btn [studentId]="element.ID" [type]="'string'" [displayText]="element.MSD_NUMBER">
                    </edit-child-modal-btn>

                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SSID">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Current SSID</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.SSID}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Dob">
                <mat-header-cell *matHeaderCellDef mat-sort-header> DOB</mat-header-cell>
                <mat-cell *matCellDef="let element">

                    {{element.DOB | shortDateTime }}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Sex">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Gender</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.SEX}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="CalpadInquiryDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Calpad Inquiry Date</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.CREATED_DATE | shortDateTime }}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
</div>
<mat-paginator [pageSizeOptions]="[10, 25,50, 100]" aria-label="Select page of users"></mat-paginator>